var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('div',[_c('apexchart',{attrs:{"width":"100%","height":"320","type":"area","options":_vm.chartOptions,"series":_vm.series}})],1):_c('div',[_c('b-skeleton-img',{staticStyle:{"height":"320px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }